// extracted by mini-css-extract-plugin
module.exports = {"validate":"resetsuccess_validate__hI0vN"};